import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

export enum TeamRosterDetailFields {
  person = 'person',
  startDate = 'startDate',
  endDate = 'endDate',
  tags = 'tags',
  status = 'status'
}

export const TeamRosterDetailSystemColumns: ItemPickerModel[] = [
  new ItemPickerModel(TeamRosterDetailFields.person, '', 'Person'),
  new ItemPickerModel(TeamRosterDetailFields.startDate, '', 'Start'),
  new ItemPickerModel(TeamRosterDetailFields.endDate, '', 'End'),
  new ItemPickerModel(TeamRosterDetailFields.tags, '', 'Tags'),
  new ItemPickerModel(TeamRosterDetailFields.status, '', 'Status')
];
